import { useSelector } from 'react-redux';
import { useOnResizeValue } from '../../../../shared/hooks/useOnResizedValue';
import { beatsSelector } from '../../../beats/beats.selector';
import { useAxisScale } from '../../../plot/hooks/useAxisScale';
import { useScale } from '../../../plot/hooks/useScale';
import { projectedBaseClusterSelector } from '../../selectors/cluster.selectors';
import {
  ClusterPlotContainer,
  PLOT_HEIGHT_PERCENTAGE,
  PLOT_WIDTH_PERCENTAGE,
} from '../genericClusterPlotUtils/ClusterPlotContainer';
import { LorenzGraph } from './LorenzGraph';

const DURATION = 2000;

export const LorenzPlot: React.FC = () => {
  const cluster = useSelector(projectedBaseClusterSelector);
  const beats = useSelector(beatsSelector);
  const height = useOnResizeValue(
    () => window.innerHeight * PLOT_HEIGHT_PERCENTAGE,
  );
  const width = useOnResizeValue(
    () => window.innerWidth * PLOT_WIDTH_PERCENTAGE,
  );
  const xScale = useAxisScale({
    size: DURATION,
    end: width,
  });
  const yScale = useScale({
    domain: { start: DURATION, end: 0 },
    range: { end: height },
  });

  if (cluster == null) {
    return <></>;
  }

  return (
    <ClusterPlotContainer
      yScale={yScale}
      xScale={xScale}
      duration={DURATION}
      xLabel={'RR Before'}
      yLabel={'RR After'}
    >
      <LorenzGraph beats={beats} yScale={yScale} xScale={xScale} />
    </ClusterPlotContainer>
  );
};
